export function formatQuota(quota, raffleTotal) {
  const totalDigits = String(raffleTotal - 1).length;
  const quotaNumber = Number(quota);
  
  if (quotaNumber === 0) {
    return String(0).padStart(totalDigits, '0');
  }

  return String(quotaNumber).padStart(totalDigits, '0');
};